import React from 'react';

import {DATA_FRAME_DISPLAY_ROW_LIMIT} from 'analysis-tool/AnalysisToolConstants';
import {DataFrame} from 'data-frames/DataFrameTypes';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {PrimaryActionRenderFn, ToolbarActionRenderParams} from '../DataFrameActionToolbar';

export function getRenderFlagRowsButtonFn(
  onClick: (selectedRowIds: Set<string>) => void
): PrimaryActionRenderFn {
  return (dataFrame: DataFrame, params: ToolbarActionRenderParams) => {
    // TODO(BNCH-112752): Disable if there are no selected rows that aren't already flagged

    const isDisabled = dataFrame.numRows ? dataFrame.numRows > DATA_FRAME_DISPLAY_ROW_LIMIT : false;
    return (
      <Tooltip
        text="Flagging rows is disabled for large tables."
        isDisabled={!isDisabled}
        key="FlagRowsButtonTooltip"
      >
        <Button
          key="FlagRowsButton"
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          className="u-mini-spacing-left"
          icon="flag"
          onClick={() => {
            onClick(params.selectedRowIds);
          }}
          disabled={dataFrame.numRows ? dataFrame.numRows > DATA_FRAME_DISPLAY_ROW_LIMIT : false}
          size={ButtonSize.MINI}
          text="Flag"
        />
      </Tooltip>
    );
  };
}
